module.exports = __webpack_public_path__ + "static/media/21.546e94b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/21.jpg
// module id = 592
// module chunks = 0